module.exports = __webpack_public_path__ + "39219455f4a60411dd4292648f64f51c.svg";